import {remCalc} from '_themeUtils'

const filterButton = {
    FilterButton: {
        baseStyle: () => ({
            filterButtonWrapper: {
                w: {base: '50%', md: 'fit-content'},
            },
            filterTextLinkWrapper: {
                w: 'fit-content',
            },
            filterToggleWrapper: {
                alignItems: 'center',
            },
            filterTriggerLabel: {
                textStyle: 'paragraphMd',
                textTransform: 'uppercase',
                color: 'color.text.black',
                letterSpacing: remCalc(0.6),
                fontWeight: 400,
                _hover: {
                    color: 'color.text.black',
                },
                _focus: {
                    color: 'color.text.black',
                },
            },
            filterTotalLabel: {
                textStyle: 'paragraphSm',
                letterSpacing: remCalc(1),
                fontWeight: 400,
                ml: 'spacing.4',
            },
            filterIcon: {
                transition: 'transform 0.2s ease-in-out',
            },
            filterIconOpened: {
                transform: 'rotate(180deg)',
            },
        }),
    },
}

export default filterButton
